.mark {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-sm);
  object-fit: contain;
  flex-shrink: 0;
}

.lockup {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}
